import { of } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { ServerResponseStatus } from "../../../api/types.js";
import "immer";
import "moment-timezone";
import "react-intl";
import "@apollo/client/errors";
import "@apollo/client";
import "graphql";
import "@opentelemetry/api";
import "../../../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import "../../bulk-operation/actions.js";
import "../../bulk-operation/components/BulkActionButton.js";
import "../../bulk-operation/epics.js";
import "../../bulk-operation/hooks.js";
import "../../bulk-operation/reducers.js";
import "../../bulk-operation/selectors.js";
import { failedOperationId, BulkActionKey } from "../../bulk-operation/types.js";
import "../../bulk-operation/components/BulkExecutionStepDetailsContent.js";
import "../../bulk-operation/components/BulkExecutionStepModal.js";
import "../../bulk-operation/components/BulkSummaryStepActionItem.js";
import "../../bulk-operation/components/BulkSummaryStepHoc.js";
import "../../../components/chip/ChipRenderer.js";
import "../../../components/chip/Chips.js";
import "../../../components/chip/ListWithChipTooltip.js";
import "../../../components/chip/SquaredChipList.js";
import "@mui/material";
import "../../../components/icons/Icon.js";
import "../../../components/icons/ExpandMoreIcon.js";
import "../../bulk-operation/components/DataGrid.js";
import "../../bulk-operation/components/BulkStepValidationSummary.js";
import "../../../components/progress/CircularProgress.js";
import "../../../components/progress/CircularProgressWithLabel.js";
import "../../bulk-operation/components/BulkSummaryStepActionLabel.js";
import "../constants.js";
import "../types.js";
class PerformP2PTransfersStrategy {
  _transactionService;
  constructor(transactionService) {
    this._transactionService = transactionService;
  }
  process({ items }) {
    const timeout = 1e4;
    const retries = 3;
    const payload = {
      timeout,
      retries,
      items: items.map((i) => ({
        id: i.itemId,
        data: {
          p2p_transfer: {
            amount: i.value?.amount,
            uid: i.value?.uid,
            type: i.value?.transaction_type
          }
        }
      }))
    };
    return this._transactionService.addP2PTransfers(payload).pipe(
      map((response) => ({
        actionKey: BulkActionKey.P2PTransfer,
        id: response?.status === ServerResponseStatus.Success ? response?.responsePayload?.id : failedOperationId
      })),
      catchError(() => of({ actionKey: BulkActionKey.P2PTransfer, id: failedOperationId }))
    );
  }
}
export {
  PerformP2PTransfersStrategy
};
//# sourceMappingURL=performStrategy.js.map
